<template>
  <div>
    <navTabs />
    <router-view />
  </div>
</template>

<script>
import navTabs from '@/components/common/ui/navTabs.vue'
export default {
  components: {
    navTabs
  },
  data () {
    return {

    }
  },
  methods: {

  }

}
</script>
